import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/buffer': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M427.8 380.7l-196.5 97.8c-1.9 0.8-5.2 1.5-7.3 1.5-2.1 0-5.4-0.7-7.3-1.5l-196.5-97.8c-4-2-4-5.3 0-7.3l47.1-23.4c1.9-0.8 5.2-1.5 7.3-1.5 2.1 0 5.4 0.7 7.3 1.5l134.8 67c1.9 0.8 5.2 1.5 7.3 1.5 2.1 0 5.4-0.7 7.3-1.5l134.8-67c1.9-0.8 5.2-1.5 7.3-1.5s5.4 0.7 7.3 1.5l47.1 23.4c4 2 4 5.2 0 7.2zM427.8 244.1c4 2 4 5.3 0 7.3l-196.5 97.8c-1.9 0.8-5.2 1.5-7.3 1.5-2.1 0-5.4-0.7-7.3-1.5l-196.5-97.8c-4-2-4-5.3 0-7.3l47.1-23.4c1.9-0.8 5.2-1.5 7.3-1.5 2.1 0 5.4 0.7 7.3 1.5l134.8 67.1c1.9 0.8 5.2 1.5 7.3 1.5s5.4-0.7 7.3-1.5l134.8-67.1c1.9-0.8 5.2-1.5 7.3-1.5s5.4 0.7 7.3 1.5zM20.2 130.4c-4-1.9-4-4.9 0-6.7l196.5-90.3c2-0.8 5.2-1.4 7.3-1.4s5.4 0.6 7.3 1.4l196.5 90.3c4 1.9 4 4.9 0 6.7l-196.5 90.3c-2 0.8-5.2 1.4-7.3 1.4s-5.4-0.6-7.3-1.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/buffer.js
// module id = 739
// module chunks = 0